(function () {
  const instances = new Map();

  const init = () => {
    document.querySelectorAll('[data-swiper="multicolumn"]').forEach(track => {
      const isMobile = window.innerWidth < 768;
      const existing = instances.get(track);

      if (isMobile && !existing) {
        const pagination = track.querySelector('.swiper-pagination');
        const instance = new Swiper(track, {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: pagination,
            clickable: true,
          },
        });
        instances.set(track, instance);
      } else if (!isMobile && existing) {
        existing.destroy(true, true);
        instances.delete(track);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 150);
  });
})();
